import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer con compatibilidad amplia de eventos
 * - Escucha CartAddEvent.eventName (nativo del tema)
 * - También escucha 'cart:added' y 'cart:open' (eventos genéricos)
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    // Nativo del tema (cuando ProductForm lanza CartAddEvent)
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Compatibilidad con eventos genéricos
    document.addEventListener('cart:added', this.#handleCartAddedGeneric);
    document.addEventListener('cart:open', this.#handleCartOpenGeneric);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('cart:added', this.#handleCartAddedGeneric);
    document.removeEventListener('cart:open', this.#handleCartOpenGeneric);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    } else {
      // Si no tiene auto-open, abrimos igualmente para asegurar UX
      this.showDialog();
    }
  };

  // Evento genérico: añadir => abrir
  #handleCartAddedGeneric = () => {
    this.showDialog();
  };

  // Evento genérico: abrir solicitado
  #handleCartOpenGeneric = () => {
    this.showDialog();
  };

  open() {
    this.showDialog();

    // Cerrar si el CTA de plazos de pago abre diálogo (evitar superposición)
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
